import CSS from './CloseButton.module.css';
import CloseIcon from '@CS/assets/close.svg?component';

type CloseButtonProps = { onClick?: () => void };

export const CloseButton = ({ onClick }: CloseButtonProps) => (
  <button onClick={onClick} className={CSS.closeButton} role="button">
    <CloseIcon />
  </button>
);
